var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowIcon = function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.462.01a.71.71 0 0 1 .467 1.257L2.585 4.99l4.344 3.72a.71.71 0 1 1-.922 1.074L1.034 5.528a.71.71 0 0 1 0-1.08L6.007.188A.7.7 0 0 1 6.462.01"
  })));
};
export { SvgArrowIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjEwIiBmaWxsPSJub25lIiB2aWV3Ym94PSIwIDAgOCAxMCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNNi40NjIuMDFhLjcxLjcxIDAgMCAxIC40NjcgMS4yNTdMMi41ODUgNC45OWw0LjM0NCAzLjcyYS43MS43MSAwIDEgMS0uOTIyIDEuMDc0TDEuMDM0IDUuNTI4YS43MS43MSAwIDAgMSAwLTEuMDhMNi4wMDcuMTg4QS43MS43MSAwIDAgMSA2LjQ2Mi4wMVoiLz48L3N2Zz4=";